import './SidebarArovyLogo.scss';

import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import ArovyIconWhite from 'images/integration-logos/ArovyIcon-White.svg';
import ArovyLogoWhite from 'images/integration-logos/ArovyLogo-White.svg';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Link } from 'react-router-dom';
import React from 'react';
import { useAmplitude } from '@hooks';

const arovyLogoAlt = 'Arovy';

function SmallLogo() {
	return (
		<img
			alt={ arovyLogoAlt }
			src={ ArovyIconWhite }
			style={ {
				width: '36px'
			} } />
	);
}

function BigLogo() {
	return (
		<img
			alt={ arovyLogoAlt }
			src={ ArovyLogoWhite }
			style={ {
				width: '128px'
			} } />
	);
}

export interface SidebarArovyLogoProps {
	isClosed: boolean;
}

export const SidebarArovyLogo: React.FC<SidebarArovyLogoProps> = ({ isClosed }) => {
	const logEvent = useAmplitude();

	const handleClick = () => {
		logEvent({ id: AMPLITUDE_EVENT.DASHBOARD_CLICKED });
	};

	return (
		<Link
			className='menu-arovy-logo'
			onClick={ handleClick }
			to={ FULL_ROUTES.DASHBOARD }>
			<span>{ isClosed ? <SmallLogo /> : <BigLogo /> }</span>
		</Link>
	);
};
